import React from 'react'
import {
  Button,
  Flex,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text
} from '@chakra-ui/react'
import { MdKeyboardArrowDown } from '@icons/index'
import moment from 'moment'

export const DateFilter = ({
  text,
  setFilter
}: {
  text: string
  setFilter: (filter: any) => any
}) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<MdKeyboardArrowDown />}
        bg={'white !important'}
        justifyContent={'end'}
        p={0}
        gap={2}
        _hover={{
          bg: 'white'
        }}
        _focus={{
          bg: 'white'
        }}
      >
        <Text color={'black'} textStyle="filterText">
          {text}
        </Text>
      </MenuButton>
      <MenuList>
        <MenuItem _hover={{ bg: 'white' }}>
          <Input
            type="date"
            onChange={(e: any) =>
              setFilter((pre: any) => {
                return { ...pre, date: e.target.value }
              })
            }
          />
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

interface PropsType {
  setFilter: (filter: any) => any
  filter: any
}

const BlogFilter = ({ setFilter, filter }: PropsType) => {
  return (
    <Flex mt={10}>
      <Flex gap={5} alignItems={'center'}>
        <Text
          onClick={() =>
            setFilter((pre: any) => {
              return { ...pre, date: undefined }
            })
          }
          color={'black'}
          textStyle="filterText"
          cursor={'pointer'}
        >
          All Articles
        </Text>
        <DateFilter
          text={
            filter.date ? moment(filter.date).format('D/M/YYYY') : 'Choose Date'
          }
          setFilter={setFilter}
        />
      </Flex>
    </Flex>
  )
}

export default BlogFilter
